import { SLOT_VIP_TASK_ITEM_TYPES, VipTaskItemTypesEnum } from '@shared/constants';

import { VipTaskItemFormValues } from '../VipSettingsForms';

export const getVipTaskItemSpecificFieldsValue = (values: VipTaskItemFormValues) => {
  const {
    type,
    userIdentifierType,
    joinedTournamentsStartDate,
    joinedTournamentsCount,
    completedTasksCount,
    gameId,
    taskX,
    betLimit,
    lowerRangeX,
    upperRangeX,
    lowerLimitX,
    totalTaskX,
    countTaskX,
  } = values;

  const isSlotType = SLOT_VIP_TASK_ITEM_TYPES.includes(type);

  return {
    userIdentifierType: type === VipTaskItemTypesEnum.VALIDATE_PARTNER_ACTION ? userIdentifierType : undefined,
    joinedTournamentsStartDate:
      type === VipTaskItemTypesEnum.JOIN_TOURNAMENTS ? joinedTournamentsStartDate.format() : undefined,
    joinedTournamentsCount: type === VipTaskItemTypesEnum.JOIN_TOURNAMENTS ? joinedTournamentsCount : undefined,
    completedTasksCount: type === VipTaskItemTypesEnum.COMPLETE_TASKS ? completedTasksCount : undefined,
    gameId: isSlotType ? gameId : undefined,
    betLimit: isSlotType ? betLimit : undefined,
    taskX:
      type === VipTaskItemTypesEnum.SLOT_HIT_X || type === VipTaskItemTypesEnum.SLOT_COUNT_HIT_X ? taskX : undefined,
    lowerRangeX: type === VipTaskItemTypesEnum.SLOT_SPECIFIC_X ? lowerRangeX : undefined,
    upperRangeX: type === VipTaskItemTypesEnum.SLOT_SPECIFIC_X ? upperRangeX : undefined,
    lowerLimitX: type === VipTaskItemTypesEnum.SLOT_SUM_X ? lowerLimitX : undefined,
    totalTaskX: type === VipTaskItemTypesEnum.SLOT_SUM_X ? totalTaskX : undefined,
    countTaskX: type === VipTaskItemTypesEnum.SLOT_COUNT_HIT_X ? countTaskX : undefined,
  };
};
